import "./home.css"; // Import CSS for this component
import ThreeScene from "../../utils/object";
import { Button } from "../../utils/button";
import { FaRocket, FaShieldAlt, FaBrain } from "react-icons/fa";
import { useEffect } from "react";



const Home = () => {
  useEffect(() => {
    const target = localStorage.getItem("scrollToSection");
    if (target) {
      const el = document.getElementById(target);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        localStorage.removeItem("scrollToSection");
      }
    }
  }, []);

  return (
    <section className="section" id="home">
      <div className="content">
        <div className="introduction">

          <h1 className="main-heading">
            Build the Future with{" "}
            <br className="desktop-break" />
            <span className="gradient-text">Generative AI</span>
          </h1>

          <p className="subtext">
            Delivering end-to-end digital innovation. From high-performance websites and mobile apps to agentic and conversational AI—crafted uniquely to match your vision and fuel your success
          </p>

          <div className="button-group">
            <Button text="Explore Services" onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })} />
            <button className="btn btn-outline" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
              Contact Us
            </button>
          </div>

          <div className="feature-points">
            <div className="feature-point">
              <FaRocket className="feature-icon" />
              <span>End-to-End Deployment</span>
            </div>
            <div className="feature-point">
              <FaShieldAlt className="feature-icon" />
              <span>Quality Engineering</span>
            </div>
            <div className="feature-point">
              <FaBrain className="feature-icon" />
              <span>AI-Powered Development</span>
            </div>
          </div>
        </div>
      </div>
      <div className="threedobject">
        <ThreeScene />
      </div>
    </section>
  );
};

export default Home;
